
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/payment",
      function () {
        return require("private-next-pages/info/payment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/payment"])
      });
    }
  